import styled from 'styled-components';
import {
  AA_SURFACE,
  AA_TEXT_PRIMARY_ON_LIGHT,
  AA_LINK_ON_LIGHT,
} from '~/modules/Helper/contrast.helper';

export const Container = styled.div`
  margin-bottom: 12px;
  background: ${AA_SURFACE};
  border: 1px solid #e6e8eb;
  border-radius: 8px;
  overflow: hidden;
`;

export const IconSection = styled.div`
  margin-right: 5px;
`;

export const Content = styled.div`
  padding: 10px;
  font-size: ${({ theme }) => `${14 + 2 * theme.zoomFonte}px`};
  color: ${AA_TEXT_PRIMARY_ON_LIGHT};

  /* AccessMonitor justif_txt_02 (AAA 1.4.8) — CMS pode mandar text-align:justify */
  &,
  & * {
    text-align: left !important;
  }

  a {
    color: ${AA_LINK_ON_LIGHT};
  }
`;
